'use client'

import React from 'react'
import { MobileAppPromotion } from './mobileAppPromotion'

interface MobileAppPromotionWrapperProps {
    // No props needed as this component manages its own state
}

const MobileAppPromotionWrapper: React.FC<MobileAppPromotionWrapperProps> = () => {
    // Business logic can be added here if needed
    // For now, this is a pure presentation component

    return (
        <MobileAppPromotion />
    )
}

export { MobileAppPromotionWrapper }
export default MobileAppPromotionWrapper
